import React from 'react';

import {
    Backdrop,
    Box,
    CircularProgress,
    Paper,
    TableContainer,
} from '@mui/material';

import MobileProductItem from './MobileProductItem';

import type { CartItemChangeProps, CartLineItem } from 'models/Cart';

interface MobileProductsListProps {
    items: CartLineItem[];
    handleChange: (props: CartItemChangeProps) => void;
    updatingCart: boolean;
}

const MobileProductsList: React.FC<MobileProductsListProps> = ({
    items,
    handleChange,
    updatingCart,
}) => {
    const handleDelete = (id: string) => {
        handleChange?.({
            qty: 0,
            rowID: id,
            remove: true,
        });
    };

    const handleQuantityChange = (id: string, quantity: number) => {
        handleChange({
            qty: Number(quantity),
            rowID: id,
            remove: false,
        });
    };

    return (
        <TableContainer component={Paper}>
            <Box sx={{ padding: '12px' }}>
                {items.map((item, key) => (
                    <MobileProductItem
                        key={key}
                        item={item}
                        updatingCart={updatingCart}
                        onDelete={handleDelete.bind(this, item.id)}
                        onChangeQuantity={(quantity: number) =>
                            handleQuantityChange(item.id, quantity)
                        }
                    />
                ))}
            </Box>
            <Backdrop
                open={updatingCart}
                sx={{
                    color: '#fff',
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </TableContainer>
    );
};

export default MobileProductsList;
